import { TOfferCalculatorState } from '../types/redux/store';

export const selectSelectedRegion = (state: TOfferCalculatorState) => state.calculator.selectedRegion;
